import React, { type PropsWithChildren } from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Queries } from "@/queries/Queries.ts";
import type { Theme } from "@/theme/CreateTheme.ts";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardFooter } from "@/uiKit/atoms/CardFooter.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type PatientSyncGuardProps = PropsWithChildren<{}>;

export const PatientSyncLibreviewGuard: React.FC<PatientSyncGuardProps> = ({ children }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const libreviewStatus = Queries.patientSync.useLibreViewStatus({});

  if (libreviewStatus.status !== "ok") {
    return (
      <Card className={cx(styles.container)}>
        <CardHeader title={t("patientSync.accessDenied")} classes={{ title: styles.title }} />
        <CardContent>
          <Typography className={styles.text}>{t("patientSync.accessDeniedDescription")}</Typography>
        </CardContent>
        <CardFooter />
      </Card>
    );
  }

  return <>{children}</>;
};

const makeStyles = (theme: Theme) => ({
  container: css({}),
  title: css({ color: theme.palette.error.dark }),
  text: css({ whiteSpace: "pre-wrap" }),
});
